import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class KontoService extends BaseService {
  
    constructor(protected http: HttpClient) { 
      super(http);
    }

    public getKontos(): Observable<any> {
        let url = '/konto';
        return this.get(url);
    }

    public getKonto(kontoId: number): Observable<any> {
        let url = '/konto/' + kontoId;
        return this.get(url);
    }
}